var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoTransaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 141,
    viewBox: "0 0 139 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.1177 124.837C103.918 124.837 130.518 98.4365 130.518 65.8365C130.518 33.2365 103.918 6.83655 71.1177 6.83655C38.3177 6.83655 11.7177 33.2365 11.7177 65.8365C11.7177 98.4365 38.3177 124.837 71.1177 124.837Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.618 58.1365V94.2365C116.618 101.737 110.518 107.837 102.918 107.837H39.5176C32.0176 107.837 25.9176 101.837 25.8176 94.3365C25.8176 94.2365 25.8176 94.2365 25.8176 94.1365V58.1365C25.8176 58.0365 25.8176 58.0365 25.8176 57.9365C25.8176 57.7365 25.8176 57.5365 25.9176 57.3365C26.0176 57.0365 26.1176 56.8365 26.2176 56.5365L43.2176 24.0365C43.8176 22.7365 45.1176 22.0365 46.5176 22.0365H95.8176C97.2176 22.0365 98.4176 22.7365 99.1176 24.0365L116.118 56.5365C116.218 56.7365 116.318 57.0365 116.418 57.3365C116.618 57.5365 116.618 57.8365 116.618 58.1365Z",
    fill: "#D5DDEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1706_2660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.618 58.1365V97.9365C116.618 103.437 112.218 107.837 106.618 107.837H35.8176C30.3176 107.837 25.8176 103.437 25.8176 97.9365V57.9365C25.8176 57.7365 25.8176 57.5365 25.9176 57.3365H48.7176C52.1176 57.3365 54.9176 60.0365 54.9176 63.5365C54.9176 65.2365 55.6176 66.8365 56.7176 67.9365C57.9176 69.1365 59.3176 69.7365 61.1176 69.7365H81.4176C84.8176 69.7365 87.6176 67.0365 87.6176 63.5365C87.6176 61.8365 88.3176 60.2365 89.4176 59.1365C90.6176 57.9365 92.0176 57.3365 93.7176 57.3365H116.418C116.618 57.5365 116.618 57.8365 116.618 58.1365Z",
    fill: "url(#paint0_linear_1706_2660)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129 37.6365C131.264 37.6365 133.1 35.8009 133.1 33.5365C133.1 31.2722 131.264 29.4365 129 29.4365C126.736 29.4365 124.9 31.2722 124.9 33.5365C124.9 35.8009 126.736 37.6365 129 37.6365Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.9 24.3366C126.446 24.3366 127.7 23.083 127.7 21.5366C127.7 19.9902 126.446 18.7366 124.9 18.7366C123.354 18.7366 122.1 19.9902 122.1 21.5366C122.1 23.083 123.354 24.3366 124.9 24.3366Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 33.5365C13.0463 33.5365 14.3 32.2829 14.3 30.7365C14.3 29.1901 13.0463 27.9365 11.5 27.9365C9.95355 27.9365 8.69995 29.1901 8.69995 30.7365C8.69995 32.2829 9.95355 33.5365 11.5 33.5365Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 95.1366C8.07188 95.1366 10.4 92.8084 10.4 89.9366C10.4 87.0647 8.07188 84.7366 5.2 84.7366C2.32812 84.7366 0 87.0647 0 89.9366C0 92.8084 2.32812 95.1366 5.2 95.1366Z",
    fill: "#EAEEF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2377 10.0056C97.5427 24.2528 98.1953 27.5155 95.2405 40.4182C94.2796 43.2868 93.3187 46.4285 91.2596 48.6141C88.3768 52.029 83.1604 53.5316 78.9049 52.4388C74.5122 51.346 70.9431 47.5213 70.1194 42.877C69.4331 40.0084 70.394 36.5935 72.8649 34.8177C75.4731 33.1786 79.1795 33.5884 81.3759 35.6373C83.8468 37.6863 84.8077 40.828 84.6704 43.8332C84.5332 46.8383 83.435 49.8435 81.925 52.4388C78.5115 58.8204 77.1062 58.797 70.1195 69.278",
    stroke: "#ABB5CC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.891 4.6994C103.37 6.6032 101.282 7.29549 99.1953 6.08398C96.9342 5.04555 95.3688 4.18018 95.7167 2.44946C96.2385 0.71873 98.3256 0.545657 100.761 0.372585C103.717 0.0264395 104.239 2.7956 103.891 4.6994Z",
    fill: "#DAE2EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0202 6.42998C87.8898 7.98764 90.3248 9.02607 92.0641 7.46842C93.9774 5.73769 95.5427 4.52619 94.6731 2.79546C93.8034 1.23781 92.412 1.75702 89.4552 2.10317C87.0202 2.62239 85.9766 4.69926 87.0202 6.42998Z",
    fill: "#DAE2EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.673 0.026505C95.8905 -0.146568 97.108 0.545723 97.4558 1.58416C97.6298 1.9303 97.8037 2.44952 97.8037 2.79567C98.1515 5.21868 97.2819 7.29556 95.8905 7.46863C94.3251 7.81477 92.7597 6.08405 92.5858 3.8341C92.5858 3.14181 92.5858 2.79567 92.5858 2.27645C92.7597 1.06494 93.4555 0.199578 94.673 0.026505C94.673 0.026505 94.8469 0.026505 94.673 0.026505Z",
    fill: "#989FB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8082 84.0962C61.0753 84.0962 62.1025 83.069 62.1025 81.8019C62.1025 80.5348 61.0753 79.5076 59.8082 79.5076C58.5411 79.5076 57.5139 80.5348 57.5139 81.8019C57.5139 83.069 58.5411 84.0962 59.8082 84.0962Z",
    fill: "#989FB0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6272 84.0962C83.8943 84.0962 84.9215 83.069 84.9215 81.8019C84.9215 80.5348 83.8943 79.5076 82.6272 79.5076C81.3601 79.5076 80.3329 80.5348 80.3329 81.8019C80.3329 83.069 81.3601 84.0962 82.6272 84.0962Z",
    fill: "#989FB0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9382 99.1642H67.7452C66.6291 99.1642 65.699 98.2341 65.699 97.1179C65.699 96.0018 66.6291 95.0717 67.7452 95.0717H74.8762C75.9923 95.0717 76.9224 96.0018 76.9224 97.1179C76.9844 98.2341 76.0543 99.1642 74.9382 99.1642Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1706_2660",
    x: 3.81763,
    y: 46.3365,
    width: 134.8,
    height: 94.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1706_2660"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1706_2660",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1706_2660",
    x1: 71.188,
    y1: 56.1684,
    x2: 71.188,
    y2: 108.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransaction);
export default __webpack_public_path__ + "static/media/noTransaction.b3559f7b3e884b07081d881587a9866f.svg";
export { ForwardRef as ReactComponent };